'use client';

import { useAtomValue } from 'jotai';
import { Theme, theme } from '../../../store/theme';

type ImageByThemeProps = {
  lightImage: string,
  darkImage: string,
};

const ImageByTheme = ({ lightImage, darkImage }: ImageByThemeProps) => {
  const appTheme = useAtomValue<Theme>(theme);
  const isLightTheme = appTheme === 'light';
  const imageSrc = isLightTheme ? lightImage : darkImage;

  const styles = { paddingBottom: '22px' };

  return (
    <img
      src={imageSrc}
      alt='article'
      width='100%'
      style={styles}
    />
  );
};

export default ImageByTheme;
